<app-page-header [title]="'Vehicle Models'" [subtitle]="'Manage vehicle models for SampleStudio'"></app-page-header>
<div class="mb-6">
    <div class="flex justify-between mb-2">
        <p-ifta-label>
            <p-iconfield>
                <p-inputicon class="pi pi-search"></p-inputicon>
                <input pInputText id="vehicle_model_search" [(ngModel)]="this.search" (input)="onSearchInputChange()"
                       autocomplete="off"/>
            </p-iconfield>
            <label for="vehicle_model_search">Search vehicle model</label>
        </p-ifta-label>
        <p-button label="Add Vehicle Model" icon="pi pi-plus" (click)="this.openCreateVehicleModelDialog()" isAdmin
                  [hidden]="false"></p-button>
    </div>
    <div class="border border-gray-300 dark:border-gray-700 p-2 dark:p-0 mb-5 rounded-sm">
        <p-table
                [value]="this.vehicleModels"
                [paginator]="true"
                [rows]="this.rows"
                [totalRecords]="this.totalRecords"
                [lazy]="true"
                [first]="this.currentPage * this.rows"
                [loading]="this.loading"
                [rowsPerPageOptions]="[5, 10, 20]"
                (onLazyLoad)="this.onPageChange($event)"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th class="w-20"></th>
                    <th>Model Series</th>
                    <th>Label</th>
                    <th>Brand</th>
                    <th>Body Type</th>
                    <th>Car Class</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-vehicleModel>
                <tr>
                    <td class="w-20">
                        <img
                                [src]="vehicleModel?.image?.content?.preview?.cloudfrontUrl || 'assets/images/no-image.png'"
                                alt="Vehicle Model Image"
                                class="w-10 h-10 object-contain rounded-sm">
                    </td>
                    <td>{{ vehicleModel.modelSeries }}</td>
                    <td>{{ vehicleModel.label }}</td>
                    <td>{{ vehicleModel.brand?.label || '' }}</td>
                    <td>{{ vehicleModel.bodyType?.label || '' }}</td>
                    <td>{{ vehicleModel.carClass?.label || '' }}</td>
                    <td>
                        <div class="flex justify-end">
                            <p-button icon="pi pi-eye" text
                                      pTooltip="View vehicle model"
                                      tooltipPosition="left"
                                      routerLink="/vehicle-models/vehicle-model/{{vehicleModel.id}}"></p-button>

                            <p-button icon="pi pi-pencil" text
                                      isAdmin
                                      pTooltip="Edit vehicle model"
                                      tooltipPosition="left"
                                      (click)="this.editVehicleModel(vehicleModel)"></p-button>

                            <p-button icon="pi pi-trash" text
                                      isAdmin
                                      pTooltip="Delete vehicle model"
                                      tooltipPosition="left"
                                      (click)="this.deleteVehicleModel(vehicleModel)"
                                      severity="danger"></p-button>
                        </div>

                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<div class="flex gap-2 mb-6">
    <p-button label="Export all Vehicle Models" icon="pi pi-download" (click)="this.exportVehicleModels()"
              severity="secondary"></p-button>
</div>

<!-- Create Vehicle Model Dialog -->
<app-create-vehicle-model-dialog
        [(visible)]="this.displayCreateVehicleModelDialog"
        (vehicleModelCreated)="this.reloadVehicleModels()"
></app-create-vehicle-model-dialog>

<!-- Update Vehicle Model Dialog -->
<app-update-vehicle-model-dialog
        [(visible)]="this.displayUpdateVehicleModelDialog"
        [vehicleModel]="this.selectedVehicleModel"
        (vehicleModelUpdated)="this.reloadVehicleModels()"></app-update-vehicle-model-dialog>

